var canShowQuantityItem = (item) => {
  switch (item.type) {
    case "plan":
    case "addon":
      return item.details && item.details.pricing_model != "flat_fee"
  }
  return false;
}


class TempItem {
  constructor(title, description, amount, type, source) {
    this.title = title;
    this.description = description;
    this.amount = amount;
    this.type = type;

    // source will be present if there is only one cart item
    this.quantity = source && canShowQuantityItem(source) && (source.quantity || 1);
    this.quantity = this.quantity && parseInt(this.quantity);
  }
}



export default {

  canShowQuantity(item, getters) {
    switch (item.type) {
      case "plan":
        return getters.can_allow("change-subscription.action.allow_plan_quantity_update") && item.details && item.details.pricing_model != "flat_fee"
      case "addon":
        return getters.can_allow("change-subscription.action.allow_modify_addons") && item.details && item.details.pricing_model != "flat_fee"
    }
    return false;
  },

  canRemove(item, getters) {
    switch (item.type) {
      case "plan":
        return false;
      case "addon":
        return getters.can_allow("change-subscription.action.allow_modify_addons");
    }
    return false;
  },

  amount(item) {
    if (item.lineItem) {
      return item.lineItem.amount;
    }
    return item.details && item.details.price;
  },

  name(item) {
    if (item.lineItem) {
      return item.lineItem.description;
    }
    return item.details && (item.details.invoice_name || item.details.name);
  },

  description(item) {
    return item.details && item.details.description;
  },

  consolidateEstimate(product_items, taxes, discounts) {
    return [].concat(this._product(product_items), this._taxes(taxes), this._discounts(discounts)).filter(i => !!i);
  },

  _product(items) {
    if (items.length == 1) {
      var item = items[0];
      return new TempItem(() => this.name(item), this.description(item), this.amount(item), "product", item);
    } else {
      return new TempItem((st,t) => `${items.length}` + ' ' +  this.getItemtxt(st,t), '', items.reduce((sum, item) => {
        sum += this.amount(item);
        return sum;
      }, 0), "product")
    }
  },

  getItemtxt(st,t) {
    return (t && t('items_in_total.custom_label')) || st('cart.item_text.total');

  },

  _taxes(taxes) {
    if (taxes.length == 0) {
      return;
    }
    var name = taxes.length == 1 ?
      (taxes[0].description || taxes[0].name) :
      taxes.map((t) => t.name).slice(0, taxes.length - 1).join(', ') + " & " + taxes[taxes.length - 1].name;
    return new TempItem(name, '', taxes.reduce((sum, tax) => {
      sum += tax.amount;
      return sum;
    }, 0), "tax")
  },

  _discounts(discounts) {
    if (discounts.length == 0) {
      return;
    }
    if (discounts.length == 1) {
      var discount = discounts[0];
      var output = new TempItem(discount.description, '',
        discount.amount,
        "discount");
      if (["item_level_coupon", "document_level_coupon"].indexOf(discount.entity_type) > -1) {
        output.coupon_id = discount.entity_id;
      }
      return output;
    } else {
      return new TempItem('Discounts applied', '', discounts.reduce((sum, item) => {
        sum += discounts.amount;
        return sum;
      }, 0), "discount")
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/cart-helper.js